export const newEl = (tag = `div`, classList = [], innerText = ``) => {
  let element = document.createElement(tag);
  element.className = classList.join(` `);

  if (innerText !== ``) {
    element.innerText = innerText;
  }
  return element;
};

export const loadJS = (url, callBack, location = document.body) => {
  const scriptTag = document.createElement('script');
  scriptTag.src = url;

  if (typeof callBack === `function`) {
    scriptTag.onload = callBack;
    scriptTag.onreadystatechange = callBack;
  }
  location.appendChild(scriptTag);
};

export const loadCSS = (url, callBack, location = document.head) => {
  const linkTag = document.createElement(`link`);
  linkTag.rel = `stylesheet`;
  linkTag.type = `text/css`;
  linkTag.href = url;

  if (typeof callBack === `function`) {
    linkTag.onload = callBack;
  }
  location.appendChild(linkTag);
};

/**
 * @function camelize - underscore to camelCase
 * @see https://gist.github.com/vjt/827679
 */
export const camelize = (str = ``) => {
  return str.replace(/(?:^|[-_])(\w)/g, (_, c) => {
    return c ? c.toUpperCase() : ``;
  });
};

export const capitalizeFirstLetter = (str = ``) => str.charAt(0).toUpperCase() + str.slice(1);

export const chunkArray = (inputArray, perChunk) => {
  return inputArray.reduce((resultArray, item, index) => {
    const chunkIndex = Math.floor(index / perChunk);

    if (!resultArray[chunkIndex]) {
      resultArray[chunkIndex] = []; // start a new chunk
    }

    resultArray[chunkIndex].push(item);

    return resultArray;
  }, []);
};

/**
 * @function convertBytes - bytes to human readable format
 * @see https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript
 */
export const convertBytes = (bytes, decimals = 2) => {
  if (bytes === 0) {
    return `0 Bytes`;
  }
  const k = 1024,
    sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + ` ${sizes[i]}`;
};

export const convertUnixTime = unixtime => {
  const d = new Date(parseInt(unixtime, 10) * 1000);
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  const dayOfMonth = d.getDate() < 10 ? `0${d.getDate()}` : d.getDate();

  return `${months[d.getMonth()]} ${dayOfMonth}, ${d.getFullYear()}`;
};

export const debounced = (delay, fn) => {
  let timerID = null;
  return function (...args) {
    if (timerID) {
      clearTimeout(timerID);
    }
    timerID = setTimeout(() => {
      fn(...args);
      timerID = null;
    }, delay);
  };
};

export const execFromCRMFlash = ctx => {
  const flashString = window.localStorage.getItem(`CRM.flash`);
  if (flashString) {
    window.localStorage.removeItem(`CRM.flash`);

    const flash = JSON.parse(flashString);
    const { method, context } = getMethod(ctx, flash.action);
    if (method) {
      return `params` in flash ? method.call(context, flash.params) : method.call(context);
    }
  }
  return false;
};

export const fadeOutPreloader = contentSelector => {
  const preloader = document.querySelector(`.crm-preloader img`);
  const content = document.querySelector(contentSelector);
  if (preloader && content) {
    content.style.display = `block`;
    preloader.style.opacity = 0;
    setTimeout(() => preloader.parentNode.removeChild(preloader), 1000);
  }
};

export const getElProp = (node = document, selector, props = []) => {
  const object = {};
  const element = node.querySelector(selector);
  if (element) {
    props.forEach(prop => {
      const propName = typeof prop === `string` ? prop : prop[Object.keys(prop)[0]];
      const objProp = typeof prop === `string` ? prop : Object.keys(prop)[0];
      // вычленение inline-стилей и преобразование их в строку, разделенную ";"
      if (propName === `style`) {
        const styleString = Object.keys(element.style)
          .filter(style => !isNaN(style))
          .map(n => `${element.style[n]}: ${element.style[element.style[n]]}`)
          .join(`; `);
        if (styleString !== ``) {
          object[objProp] = styleString;
        }
      } else if (propName === `src`) {
        object[objProp] = element.src.replace(window.location.origin, ``);
      } else {
        object[objProp] = element[propName];
      }
    });
  }
  return object;
};

export const removeEnclosedNewLines = string => string.replace(/^\s+|\s+$/g, '');

export const insertAfter = (newNode, referenceNode) => {
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
};

export const getMethod = (ctx, name) => {
  const nested = name.split(`.`);
  let object = ctx;
  let context = ctx;
  nested.forEach((submethod, i) => {
    if (submethod in object) {
      object = object[submethod];
    }
    if (i === nested.length - 2) {
      context = object;
    }
  });
  return typeof object === `function` ? { method: object, context } : false;
};

export const getNofChild = element => {
  const parentNode = element.parentNode;
  return parentNode ? [...parentNode.children].indexOf(element) : -1;
};

export const toHTTPString = (params = {}) => {
  const queryParams = [];
  Object.keys(params).forEach(name => {
    if (typeof params[name] === `string` || typeof params[name] === `number` || typeof params[name] === `boolean`) {
      queryParams.push(`${name}=${encodeURIComponent(params[name])}`);
    } else if (typeof params[name] === `object` && Array.isArray(params[name])) {
      params[name].forEach(value => queryParams.push(`${name}=${encodeURIComponent(value)}`));
    }
  });
  return queryParams.join(`&`);
};

export const getCRMUserID = () => {
  const loginElement = document.querySelector(`#login_name`);
  if (loginElement && loginElement.dataset.crmuserid) {
    return parseInt(document.querySelector('#login_name').dataset.crmuserid, 10);
  }
  return null;
};

export const getPSQLTodayDate = () => {
  const d = new Date();
  const day = d.getDate();
  const month = d.getMonth() + 1;
  return `${d.getFullYear()}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;
};

export const appendSpinner = element => {
  if (element.firstElementChild && element.firstElementChild.classList.contains(`fa-spinner`)) {
    return true;
  }
  if (element) {
    const spinner = newEl(`i`, [`fa`, `fa-spinner`, `fa-spin`, `fa-fw`]);
    spinner.setAttribute('style', 'margin-right: 5px');
    element.insertBefore(spinner, element.firstChild);
    return element;
  } else {
    console.error(`appendSpinner couldn't find element on ${window.location.href}`);
    return false;
  }
};

export const fetchEventList = onload => {
  const xhr = new XMLHttpRequest();
  xhr.open(`GET`, `/crm/neuevents.json?fields=short_title&fields=begin_date&order_by=begin_date&direction=desc`);
  xhr.timeout = 10000;
  xhr.onload = evt => {
    if (evt.target.status === 200) {
      window.EPCCRM.eventList = JSON.parse(evt.target.response);
      if (typeof onload === `function`) {
        onload(window.EPCCRM.eventList);
      }
    }
  };
  xhr.onerror = () => console.error(`fetchEventList: events data hasn't been loaded`);
  xhr.send();
};

/**
 * @function serializeArray - Serialize all form data into an array
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @see https://vanillajstoolkit.com/helpers/serializearray/
 * @param  {Node}   form The form to serialize
 * @return {String}      The serialized form data
 */
export const serializeArray = form => {
  // Setup our serialized data
  const serialized = [];

  // Loop through each field in the form
  for (let i = 0; i < form.elements.length; i++) {
    const field = form.elements[i];

    // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
    if (
      !field.name ||
      field.disabled ||
      field.type === 'file' ||
      field.type === 'reset' ||
      field.type === 'submit' ||
      field.type === 'button'
    ) {
      continue;
    }

    // If a multi-select, get all selections
    if (field.type === 'select-multiple') {
      for (let n = 0; n < field.options.length; n++) {
        if (!field.options[n].selected) {
          continue;
        }
        serialized.push({
          name: field.name,
          value: field.options[n].value,
        });
      }
    } else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
      // Convert field data to a query string
      serialized.push({
        name: field.name,
        value: field.value,
      });
    }
  }
  return serialized;
};

export const getEventIDByLocation = () => {
  const pathName = window.location.pathname;
  if (/\/crm\/neuevent\/\d+\/.+/.test(pathName)) {
    const id = window.location.pathname.split('/')[3];
    if (!isNaN(id)) {
      return parseInt(id, 10);
    }
  }
  return null;
};

export const setCookie = (name = `cookie`, value = ``, days = 3) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
};

export const getCookie = name => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  return parts.length === 2 ? parts.pop().split(`;`).shift() : null;
};

export const empty = element => {
  while (element.firstChild) {
    element.removeChild(element.firstChild);
  }
};

export const lang = () => {
  // or: window.location.hostname.match(/\.ru/) ? `ru` : `en`;
  return window.location.host.split('.').reverse()[0] === `ru` ? `ru` : `en`;
};

export const objectDiff = (a, b) => {
  const diff = {
    added: [],
    removed: [],
    diff: {},
  };
  if (typeof a === `object` && typeof a === typeof b) {
    Object.keys(a).forEach(key => {
      if (key in b) {
        if ((typeof a[key] === `string` || typeof a[key] === `number`) && a[key] !== b[key]) {
          if (b[key] === ``) {
            diff.removed.push(key);
          } else {
            diff.diff[key] = [a[key], b[key]];
          }
        } else if (a[key] === null && b[key] !== null) {
          diff.added.push(key);
        } else {
          if (JSON.stringify(a[key]) !== JSON.stringify(b[key])) {
            diff.diff[key] = [a[key], b[key]];
          }
        }
      } else {
        diff.removed.push(key);
      }
    });
    Object.keys(b).forEach(key => {
      if (!a.hasOwnProperty(key)) {
        diff.added.push(key);
      }
    });
    return diff;
  } else {
    console.error(`trying to compare two objects of different types`);
    return diff;
  }
};

export const datePickerI18n = {
  days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
  daysShort: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  daysMin: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  today: 'Today',
  clear: 'Clear',
  dateFormat: 'yyyy-mm-dd',
  timeFormat: 'hh:ii aa',
  firstDay: 0,
};

// 123456,00 => 123 456,00
export const numberWithSpaces = x => {
  let parts = x.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return parts.join('.');
};

export function scrollToTargetAdjusted(element, offset = 0) {
  if (!element) {
    return;
  }

  const elementPosition = element.getBoundingClientRect().top;
  const offsetPosition = elementPosition - offset;

  window.scrollBy({
    top: offsetPosition,
    behavior: 'smooth',
  });
}
